import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen w-full flex items-center overflow-hidden" data-id="element-35">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-36">
        <img src="https://cdn.magicpatterns.com/uploads/tyQheSznjfZiZ8vXnoRvYa/image.png" alt="Handwritten letter on a desk with coffee and candle" className="w-full h-full object-cover" data-id="element-37" />
        {/* Subtle overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-cream/90 via-cream/40 to-transparent" data-id="element-38" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-20" data-id="element-39">
        <motion.div className="max-w-2xl" initial="hidden" animate="visible" variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.2,
            delayChildren: 0.3
          }
        }
      }} data-id="element-40">
          <motion.h1 className="font-serif text-5xl md:text-7xl text-charcoal leading-[1.1] mb-6" variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: 'easeOut'
            }
          }
        }} data-id="element-41">
            A handwritten love letter, delivered monthly
          </motion.h1>

          <motion.p className="font-sans text-lg md:text-xl text-warm-gray italic mb-10 max-w-lg" variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: 'easeOut'
            }
          }
        }} data-id="element-42">
            For those who miss longing, not likes.
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-4" variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.8,
              ease: 'easeOut'
            }
          }
        }} data-id="element-43">
            <a href="#subscribe" className="inline-flex items-center justify-center px-8 py-3 bg-charcoal text-cream rounded-full font-medium transition-transform hover:scale-[1.02] duration-300 shadow-lg shadow-charcoal/10" data-id="element-44">
              Get Started
            </a>
            <a href="#gift" className="inline-flex items-center justify-center px-8 py-3 border border-charcoal text-charcoal rounded-full font-medium transition-all hover:bg-charcoal/5 hover:scale-[1.02] duration-300" data-id="element-45">
              Gift a Letter
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}